import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import theme from "theme";

import PropTypes from "prop-types";

const FacebookIcon = ({ colour, ...props }) => (
  <SvgIcon {...props} viewBox="-100 -100 650 650">
    <path
      d="M468.333-1H41.667C17.773-1-1,17.773-1,41.667v426.667C-1,492.227,17.773,511,41.667,511h196.267h102.4h128 C492.227,511,511,492.227,511,468.333V41.667C511,17.773,492.227-1,468.333-1z M255,493.933V323.267h-68.267V255H255v-59.733 c0-48.64,37.547-89.6,85.333-93.867h76.8v68.267h-68.267c-14.507,0-25.6,11.093-25.6,25.6V255H408.6v68.267h-85.333v170.667H255z  M493.933,468.333c0,14.507-11.093,25.6-25.6,25.6h-128v-153.6h85.333v-102.4h-85.333v-42.667c0-5.12,3.413-8.533,8.533-8.533 H434.2v-102.4h-94.72c-57.173,5.12-101.547,53.76-101.547,110.933v42.667h-68.267v102.4h68.267v153.6H41.667 c-14.507,0-25.6-11.093-25.6-25.6V41.667c0-14.507,11.093-25.6,25.6-25.6h426.667c14.507,0,25.6,11.093,25.6,25.6V468.333z"
      stroke={colour}
      strokeWidth="25"
    />
  </SvgIcon>
);

export default FacebookIcon;

FacebookIcon.propTypes = {
  colour: PropTypes.string,
};

FacebookIcon.defaultProps = {
  colour: theme.palette.primary.main,
};
